import React, { useRef } from 'react';
import '../../Styles/Multiomics.scss';
import laborotoryimage from '../../Assests/LaboratoryImages/laborotaryPNG.png'

import bioInfoMob from '../../Assests/LaboratoryImages/bioInfoMob.png';
import expertMob from '../../Assests/LaboratoryImages/expertValMob.png';
import genoMob from '../../Assests/LaboratoryImages/genomicsMob.png';
import gutMob from '../../Assests/LaboratoryImages/gutMicroeMob.png';
import metaMob from '../../Assests/LaboratoryImages/metabolomicsMob.png';
import personalised from '../../Assests/LaboratoryImages/personalizedMob.png';
import proteomicMob from '../../Assests/LaboratoryImages/proteomicsMob.png';
import sampleMob from '../../Assests/LaboratoryImages/sampleMob.png';

function LaboratoryServiceMobile() {
    const teamSectionRef = useRef(null);

    const scrollToSection = () => {
        if (teamSectionRef.current) {
            teamSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className="advanced-multiHeight">
                <div className='row w-100 flex-mobView'>

                    <div className='col-md-6   p-5'>
                        <div className='  advanced-multi-omics overall-text-color pt-5' >

                            <div>
                                Advanced Multi-Omics
                            </div>
                            <div>
                                analysis and
                            </div>
                            <div>
                                Personalized Health
                            </div>
                            <div>
                                Solutions
                            </div>
                        </div>
                        <div className='advanced-multi-omics-sub mt-3'>
                            <div >
                                At our cutting-edge facility, we provide comprehensive health insights using advanced Multi-Omics analysis tools and expertise.
                            </div>
                        </div>
                        <div className='d-flex justify-content-center primary-btn  py-2  px-2  mt-5 fw-bold explore-btn' onClick={scrollToSection} >
                            <div>Explore Our services</div>
                            <span class="material-symbols-outlined ms-1">
                                arrow_downward
                            </span>
                        </div>
                    </div>
                    <div className='col-md-6 '>
                        <div >
                            <img className='laborotoryimage-image' alt="Laboratory equipment" src={laborotoryimage} />
                        </div>
                    </div>
                </div>
                <div className="advanced-multiomicsBackground mt-3 w-100">
                    <div
                        className="fs-1 fw-bold overall-text-color text-center center-ourservices Comprehensive-text"
                        style={{ color: '#493158' }}
                        ref={teamSectionRef}
                    >
                        Our Services Include
                    </div>


                    <div className="d-flex flex-column  mobileView-laboratory align-items-center w-100 mt-5">
                        <img src={genoMob} alt="Genomics" className="service-image  mb-4" />
                        <img src={proteomicMob} alt="Proteomics" className="service-image  mb-4" />
                        <img src={metaMob} alt="Metabolics" className="service-image  mb-4" />
                        <img src={gutMob} alt="Gut Analysis" className="service-image  mb-4" />
                        <img src={sampleMob} alt="Sample Analysis" className="service-image  mb-4" />
                        <img src={bioInfoMob} alt="Bioinformatics" className="service-image  mb-4" />

                        <img src={expertMob} alt="Expert Analysis" className="service-image  mb-4" />

                        <img src={personalised} alt="Personalized" className="service-image  mb-4" />
                    </div>

                    <div className='text-center center-ourservices fontSize-of-holistic  holistic-text '>
                        <div>With our holistic end-to-end approach from advanced
                        </div>
 
                        <div>scientific analysis and bioinformatics to personalized
                        </div>
                        <div> health recommendations, you receive reliable insights and
                        </div>
                        <div>tailored solutions to achieve your wellness goals. </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LaboratoryServiceMobile;
